<template>
  <div>
    <v-row
      class="mx-auto pb-3"
      justify="center"
      v-if="pattern && pattern.length > 0"
    >
      <v-col cols="12" class="pa-0">
        <h2 class="mt-5 text-center">
          {{ $t("pattern_table.course_registration_information") }}
        </h2>
        <h3 class="text-center mt-1">
          {{
            $t(
              "pattern_table.students_should_check_course_submission_according_to_the_course_plan"
            )
          }}
        </h3>
      </v-col>
      <v-col cols="12" sm="9" md="6" class="mb-0 pa-0">
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead class="pattern">
              <!-- --------------------------------------------------------------- -->
              <!-- Table Header -->
              <tr>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in pattern" :key="index">
                <td class="text-center">
                  <v-btn
                    small
                    icon
                    color="indigo"
                    v-if="
                      add_subject_from_pattern !== null &&
                      !is_in_registering(item.subject_id)
                    "
                    @click="add_subject(item.subject_id)"
                  >
                    <v-icon>mdi-arrow-up-thin</v-icon>
                  </v-btn>
                  {{ item.subject_id }}
                </td>
                <td class="last-cell text-center">
                  <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                    {{ item.subject_ename }}
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <subject-dialog ref="subject_dialog" />
    </v-row>
  </div>
</template>

<script>
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

export default {
  name: "PatternTable",
  components: {
    SubjectDialog,
  },
  props: {
    pattern: {
      type: Array,
    },
    add_subject_from_pattern: {
      type: Function,
      default: null,
    },
    registering_subject_list: {
      type: Array,
    },
  },
  methods: {
    is_in_registering(subject_id) {
      return this.registering_subject_list.reduce(
        (ret, item) => ret || item.subject_id == subject_id,
        false
      );
    },
    add_subject(subject_id) {
      if (this.add_subject_from_pattern !== null) {
        this.add_subject_from_pattern(subject_id);
        window.scrollTo(0, 0);
      }
    },
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
  },
};
</script>

<style>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}

thead.pattern {
  background-color: #aaa;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
